import * as React from "react";

const CompanyChatPage = React.lazy(() => import("./CompanyChat"));

const routePrefix = "/chat/company";

export const CompanyChatRoutes = [
  {
    id: "COMPANY_CHAT_ROOM",
    path: `${routePrefix}`,
    layoutId: "MainLayout",
    component: CompanyChatPage,
    navigation: {
      section: "chat",
      navGroup: "Chat",
      navTitle: "Company Chat",
    },
  },
];
